import React from "react";
import { Link } from "@quintype/components";
import assetify from '@quintype/framework/assetify';
import { StoryCard } from "../basic/story-card.js"
import { SectionName } from "../basic/section-name.js";
import { Polltype } from "../polltype";
import ArrowImg from '../../../assets/icons/readmore_arrow.svg';
import { DfpAd } from "../dfp-ad"
import { wrapCollectionLayout } from "@quintype/components";
import {collectionSection} from './collection-layout-helper';


function LShapeOneWidgetBase({collection, stories, config, associatedMetadata}) {
  const primarStoryCardConfig = {
    section: true,
    subheadline: true,
    image: true,
    imageAspectRatio: [4,3]
  }
  const storyListConfig = {
    image: true
  }
  const  {'show_collection_title': collectionName = true} = associatedMetadata;

  return (
    <div className="l-shape-grid component-wrapper">
      {collectionName ? <SectionName hideLink={true} name={collection.name} type="large" section={collectionSection(config, collection)}/> : null }
      <div className="l-shape-grid__first-row">
        <div className="feature-story">
          <StoryCard hideSectionName={true} story={stories[0]} config={primarStoryCardConfig} type="imageBackground"/>
        </div>
        <div className="app-ad app-ad--vertical">
          <DfpAd adtype="Vertical-Ad" layoutName="LShapeOneWidget" collectionSlug={collection.slug}/>
        </div>
      </div>

      <div className="l-shape-grid__second-row">
        {stories.slice(1,4).map((story) => {
          return <div className="l-shape-grid__story" key={story.id}>
            <StoryCard hideSectionName={true} config={storyListConfig} story={story}/>
          </div>
        })}
      </div>
      <Link href={'/' + collection.slug} className="l-shape-grid__read-more">
        Read more
        <img src={assetify(ArrowImg)} alt="Arrow"/>
      </Link>
      <div className="app-ad app-ad--horizontal">
        <DfpAd adtype="Horizontal-Ad" layoutName="LShapeOneWidget" collectionSlug={collection.slug}/>
      </div>
    </div>
  )

}

export const LShapeOneWidget = wrapCollectionLayout(LShapeOneWidgetBase);
